var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"roll-num"},[_vm._v(_vm._s(_vm.showNum.toFixed(_vm.digit)))])
}
var staticRenderFns = []

export { render, staticRenderFns }